<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div *ngIf="type == 'D'" class="pageTitle">
      {{ "mastertablesD.titleList" | translate }}
    </div>
    <div *ngIf="type == 'S'" class="pageTitle">
      {{ "mastertablesS.titleList" | translate }}
    </div>
    <form class="formGroup container halfForm margin0">
      <div class="lineGradient"></div>
      <div class="containerMasterTable filterTableContainer">
        <div class="row shortRow">
          <div class="itemContainer col margin0">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label id="modelo" for="modelo"> Seleccione tabla </label>
              </div>
            </div>
            <div class="inputContainer">
              <select
                *ngIf="!loading.mastertables"
                [(ngModel)]="mastertableSelected"
                name="mastertable"
                (change)="loadData(true)"
              >
                <option value="0">Selecciona una opción</option>
                <option *ngFor="let mastertable of mastertables">
                  {{ mastertable }}
                </option>
              </select>
            </div>
            <button (click)="goCreate()" class="reduceSize">
              <em class="far fa-plus-square"></em>
            </button>
            <button
              *ngIf="mastertableSelected != '0'"
              (click)="removeMastertable()"
              class="reduceSize margin5"
            >
              <em class="far fa-trash-alt"></em>
            </button>
            <button
              *ngIf="mastertableSelected != '0' && !isAnalistUser"
              type="button"
              (click)="openPermisosTablaModal()"
              class="reduceSize margin5"
              title="Permisos perfiles"
            >
              <em class="fas fa-user-shield"></em>
            </button>
          </div>
        </div>
      </div>
    </form>

    <div
      class="filterTableContainer"
      *ngIf="filterList && filterList.length > 0"
    >
      <app-filters
        #insideTable
        class="newFilters"
        *ngIf="
          mastertableSelected != '0' &&
          showTableAndFilters &&
          loading.dataOfMastertable
        "
        [filterList]="filterList"
        [ngClass]="{ filterHidden: !showTableFilter }"
        [type]="'mastertable'"
        [options]="options"
        (showFilters)="showFilters($event)"
      ></app-filters>
      <app-table
        #table
        *ngIf="
          mastertableSelected != '0' &&
          showTableAndFilters &&
          loading.dataOfMastertable
        "
        [tableList]="tableList"
        [elementList]="dataOfMastertables"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [mastertable]="mastertableSelected"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons]="showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (elementsToRemove)="removeElements($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
      ></app-table>
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
    </div>
  </div>
</div>
<app-modal-form
  #modalPermisos
  (sendForm)="savePermisosTablaRoles($event)"
  title="Permisos de tabla: {{ mastertableSelected }}"
  locatorClass="locatorPermisosTabla"
  [confirmMessage]="
    '<strong>¿Está seguro de guardar los permisos?</strong>'
  "
></app-modal-form>